import { Button, Icon } from "@culturehq/components";
import { Trans } from "app/utils";
import React from "react";
import VideoStudioIcon from "../../../common/icons/VideoStudioIcon";
import { VIDEO_TYPE } from "../utils/constants";

interface VideoStudioModalButtonProps {
  disabled?: boolean;
  mediaType: string;
  onOpen: () => void;
}

const VideoStudioModalButton: React.FC<VideoStudioModalButtonProps> = ({
  disabled, mediaType, onOpen
}) => (
  <Button className="VideoStudio-Btn" onClick={onOpen} disabled={disabled}>
    {mediaType === VIDEO_TYPE ? (
      <>
        <VideoStudioIcon />
        <Trans>Edit Video</Trans>
      </>
    ) : (
      <>
        <Icon icon="art-palette" />
        <Trans>Edit Image</Trans>
      </>
    )}
  </Button>
);

export default VideoStudioModalButton;
